<template>
  <el-dialog
    title="订单核销码"
    :visible.sync="dialogVisible"
    width="35%"
    :before-close="handleClose">
    <div class="code-wrap" v-loading="loading">
      <div class="code" v-if="sellData">
        {{sellData.sellCode | codeSplit}}
      </div>
      <div id="qrcode"></div>
      <div class="tips">商家扫码使用</div>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import {fetchOrderQrcode} from '../api/xunyou';
import QRcode from 'qrcodejs2';
export default {
  name: 'orderQrcode',
  components: {
    QRcode
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      sellData: null,
      currentOrder: null,
      qrcodeIns: null
    }
  },
  methods: {
    handleClose (done) {
      this.sellData = null;
      this.currentOrder = null;
      this.qrcodeIns.clear();
      done();
    },
    show (order) {
      this.currentOrder = order;
      this.getOrderCode();
      this.dialogVisible = true;
    },
    hide () {
      this.dialogVisible = false;
      this.sellData = null;
      this.currentOrder = null;
    },
    initQrcode () {
      if (this.qrcodeIns) {
        this.qrcodeIns.makeCode(this.sellData.sellCode);
      } else {
        this.qrcodeIns = new QRcode('qrcode', {
          width: 200,
          height: 200,
          text: this.sellData.sellCode
        });
      }
    },
    // 获取订单核销码
    getOrderCode () {
      this.loading = true;
      fetchOrderQrcode( { orderNumber: this.currentOrder.orderNumber })
        .then(res => {
          this.loading = false;
          console.log('核销信息：', res);
          if (res.code === 0) {
            this.sellData = res.data[0];
            this.initQrcode();
          } else {
            this.$message.error(res.msg);
          }
        });
    }
  },
  filters: {
    codeSplit (val) {
      return val.replace(/\s/g,'').replace(/(.{4})/g,"$1  ");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.code-wrap{
  margin: 40px auto;
  text-align: center;
  .code{
    font-weight: bold;
    font-size: 16px;
    background-color: #e3e6ee;
    width: 200px;
    margin: 10px auto;
    border-radius: 3px;
  }
  #qrcode{
    display: inline-block;
    width: 200px;
    height: 200px;
  }
  .tips{
    margin-right: 10px;
    color: #999999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderQrcode.vue